// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"styles_logoContainer__24gSW","logoText":"styles_logoText__qABrJ","a":"styles_a___MfGH","link":"styles_link__28fPV"};